import React from 'react';

const AdminSEO = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">SEO Management</h1>
      <p>Manage your SEO settings here</p>
    </div>
  );
};

export default AdminSEO;